import { PartnerRequestPasswordResetRequest } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

// Partner Portal "forgot password". Unauthenticated; the backend always answers Success so
// usernames cannot be enumerated — a Success here means "if that user exists, an email went out".
export default function useRequestPartnerPasswordReset() {
  const [submitting, setSubmitting] = useState(false);

  async function requestPasswordReset(params: PartnerRequestPasswordResetRequest) {
    try {
      setSubmitting(true);
      const res = await api.partnerRequestPasswordReset(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, requestPasswordReset };
}
